import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from './AdminManagement.slice';
import noop from 'lodash/noop';
import classnames from 'classnames';

// landscape components
import themeable from 'zignal-landscape/lib/themeable';
import Heading from 'zignal-landscape/lib/Heading';
import SearchInput from 'zignal-landscape/lib/SearchInput';
import ErrorMessage from 'zignal-landscape/lib/ErrorMessage';
import Loading from 'zignal-landscape/lib/Loading';
import InformationIcon from 'zignal-landscape/lib/Icon/InformationIcon';
import Button from 'zignal-landscape/lib/Button';
import ConfirmationModal from 'zignal-landscape/lib/ConfirmationModal';

const TITLE = 'Undelete Workspace / Dataset';

export const mapStateToProps = (
  (state) => ({
    loading: state.AdminManagement.loading,
    isOpen: state.AdminManagement.isOpen,
    isUndeletingProfile: state.AdminManagement.isUndeletingProfile,
    profile: state.AdminManagement.profile,
    error: state.AdminManagement.error,
    success: state.AdminManagement.success
  })
);

export const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, dispatchProps, ownProps);
};

const AdminManagement = ({
  styles,
  loading,
  isOpen,
  isUndeletingProfile,
  profile,
  error,
  success,
  searchProfile,
  clearSearch,
  openConfirmation,
  closeConfirmation,
  undeleteProfile
}) => {
  const [ profileId, setProfileId ] = useState('');
  const message = error || success;
  const messageType = error ? 'Error' : 'Success';
  let profileType = profile && profile.type;
  if (profileType) {
    profileType = profileType === 'Competitor' ? 'Dataset' : 'Workspace';
  }
  let modalMessage = `Undeleting this ${profileType} will also restore its \
    dependent Models, Alerts, and Jobs that were active at the time of deletion. \
    Are you sure you want to continue?`;
  if (profileType && profileType === 'Dataset') {
    modalMessage = `This action will undelete the ${profileType} and make it active. \
      Are you sure you want to continue?`;
  }
  const onChange = (val) => {
    if (val.length === 24) {
      searchProfile(val);
    }
    if ((profile || message) && val.length !== 24) {
      clearSearch();
    }
    setProfileId(val);
  };

  return (
    <div>
      <Heading>{TITLE}</Heading>
      <br />
      <div className={styles.Search}>
        <SearchInput
          data-cy="search-deleted-profile"
          id="search-input-deleted-profiles"
          placeholder="Mongo ID of deleted Workspace/Dataset"
          size="normal"
          onChange={onChange}
          divider
        />
      </div>
      { (profileId.length === 0 || profileId.length === 24) ? null : (
        <ErrorMessage data-cy="error-message">Must use valid Mongo ID</ErrorMessage>
      )}
      { loading && (
        <div className={styles.Center}>
          <Loading />
        </div>
      )}
      { message && (
        <div className={classnames(styles.Center, styles[messageType])}>
          <span className={styles.InfoIcon}><InformationIcon width={60} height={60} /></span>
          <div data-cy="message-header" className={styles.MessageHeader}>{messageType}</div>
          <div className={styles.MessageBody}>{message}</div>
        </div>
      )}
      {
        profileType && (
          <div className={styles.InfoParent}>
            <br />
            <div data-cy="profile-name" className={styles.InfoName}>{profile.name}</div>
            <div>Type: {profileType}</div>
            <div>Updated At: {profile.updated_at}</div>
            <div>Account: {profile.account.name}</div>
            { profile.campaign && <div>Workspace: {profile.campaign.name}</div> }
            <br />
            <Button data-cy="undelete-btn" buttonStyle="positive" onClick={openConfirmation}>
              Undelete this {profileType}
            </Button>
          </div>
        )
      }
      <ConfirmationModal
        data-cy="confirm-modal"
        isOpen={isOpen}
        size="small"
        confirmStyle="alert"
        title={`Undelete ${profileType}`}
        onCancel={isUndeletingProfile ? noop : closeConfirmation}
        onConfirm={isUndeletingProfile ? noop : undeleteProfile}
      >
        {modalMessage}
      </ConfirmationModal>
    </div>
  );
};

AdminManagement.propTypes = {
  styles: PropTypes.object,
  loading: PropTypes.bool,
  isOpen: PropTypes.bool,
  isUndeletingProfile: PropTypes.bool,
  profile: PropTypes.object,
  error: PropTypes.string,
  success: PropTypes.string,
  // // actions
  searchProfile: PropTypes.func,
  clearSearch: PropTypes.func,
  openConfirmation: PropTypes.func,
  closeConfirmation: PropTypes.func,
  undeleteProfile: PropTypes.func
};

export default connect(mapStateToProps, actions, mergeProps)(themeable(AdminManagement));
